<template>
  <CSidebar
    color-scheme="light"
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <CSidebarBrand>
      <img class="d-block sidebar-brand-full" :src="logo" alt="HCL Foundation"  height="35"/>
      <img class="sidebar-brand-narrow" :src="logo" alt="HCL Foundation"  height="35"/>
      <!-- <CSidebarToggler @click="$store.commit('toggleUnfoldable')" /> -->
    </CSidebarBrand>
    <AppSidebarNav />
  </CSidebar>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import { logoNegative } from '@/assets/brand/logo-negative'
import { sygnet } from '@/assets/brand/sygnet'
import logo from '@/assets/images/hclf-logo-new.png';
export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const store = useStore()
    return {
      logoNegative,
      sygnet,
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      logo
    }
  },
}
</script>
